<template>
  <div class="settings-header">
      {{ title }}
  </div>
</template>

<script>
/**
 * @todo Perhaps it's better to extract whole settings layout as a separate component
 */
export default {
  name: 'SettingsHeader',
  props: {
    title: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
  .settings-header {
    display: none;

    @include md-up {
      align-items: center;
      background-color: $stepperBackground;
      color: $secondary;
      display: flex;
      font-size: 14px;
      font-weight: 500;
      height: 124px;
      letter-spacing: .19px;
      padding: 0 60px;
      width: 100%;
    }
  }
</style>
